// @ts-expect-error - Automatic, Please fix when editing this file
const uncapFpIterator = (fn) => fn.convert({ cap: false });

export default uncapFpIterator;
